import React from "react";

export default function ErrorBoundaryComp() {
  return <div>Something went wrong. Please refresh the page.</div>;
}
